import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Tent } from "lucide-react";

const links = [
  { to: "/search", label: "Search" },
  { to: "/deals", label: "Deals" },
  { to: "/regions", label: "Regions" },
  { to: "/guides", label: "Guides" },
];

export default function Nav({ transparent = false }) {
  return (
    <header
      className={`sticky top-0 z-40 ${transparent ? "bg-transparent" : "bg-sand/85 backdrop-blur-xl border-b border-border"}`}
      data-testid="site-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-home-logo">
          <span className="w-9 h-9 rounded-lg bg-forest text-white flex items-center justify-center group-hover:bg-forest-dark transition-colors">
            <Tent className="w-5 h-5" />
          </span>
          <span className="font-display font-bold text-xl text-ink">ParkScanner</span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  isActive ? "bg-forest text-white" : "text-ink/80 hover:bg-white"
                }`
              }
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <Link
          to="/search"
          className="btn-primary text-sm px-4 py-2"
          data-testid="nav-cta-search"
        >
          Find a park
        </Link>
      </div>
    </header>
  );
}
